import { ref } from "vue";

export const StorableRef = (key: string, defaultValue: number) => { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  const setter = (val) => {
    try {
      localStorage.setItem(key, val);
    } catch (e) {
      // localstorageが使えなくても何もしない
    }
  };

  const refVal = ref(defaultValue);
  try {
    const storageVal = localStorage.getItem(key);
    if (storageVal) {
      refVal.value = Number(storageVal);
    }
  } catch (_) {
    // localstorageが使えなくても何もしない
  }

  return [refVal, setter] as const;
};
